import { Style, Stroke, Fill, Circle as CircleStyle, Icon } from "ol/style";
import { Point } from "ol/geom";
import { Feature } from "ol";
import { fromLonLat } from "ol/proj";

/**
 * Returns an OpenLayers style (or array of styles) based on layer name and geometry type.
 * Adds green bold lines + direction arrows for optimized routes.
 */
export function getLayerStyle(name = "", geometry_type = "LINESTRING") {
    const lname = name.toLowerCase();

    // 🟢 Optimized Route (Green Bold + Direction Arrows)
    if (lname.includes("optimized") && geometry_type === "LINESTRING") {
        return (feature, resolution) => {
            const styles = [];

            // main bold green line
            styles.push(
                new Style({
                    stroke: new Stroke({
                        color: "rgba(0, 200, 0, 1)",
                        lineDash: [4, 10],
                        width: 4,
                    }),
                })
            );

            return styles;
        };
    }

    // 🔵 Default styles
    switch (geometry_type.toUpperCase()) {
        case "POINT":
            return new Style({
                image: new CircleStyle({
                    radius: 7,
                    fill: new Fill({ color: "rgba(0, 34, 255, 0.89)" }),
                    stroke: new Stroke({ color: "#000000ff", width: 4 }),
                }),
            });

        case "LINESTRING":
            return new Style({
                stroke: new Stroke({
                    color: "#ff3333ff",
                    width: 4,
                }),
            });

        case "POLYGON":
            return new Style({
                stroke: new Stroke({
                    color: "#3388ff",
                    width: 2,
                }),
                fill: new Fill({
                    color: "rgba(51, 136, 255, 0.2)",
                }),
            });

        default:
            return new Style({
                stroke: new Stroke({
                    color: "#999",
                    width: 1.5,
                }),
            });
    }
}
